const style = {
  boxGrid: {
    gridTemplateColumns: {
      xs: "repeat(1, 1fr)",
      lg: "repeat(12, 1fr)",
    },
    // p:3,
  },
  imageTypography: {
    mx: {
      xs: 1,
      lg:4,
    },
    fontSize: 14,
    my: 2,
  },
};
export default style;
